// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VmpJpXusOUpJVZaBvBFA{flex-wrap:unset;overflow-x:auto}.oWV6gR_AC4h6b2ZTX9SM{flex-shrink:0}`, "",{"version":3,"sources":["webpack://./src/components/asset-management-system/custom-views/asset-custom-view-page.scss"],"names":[],"mappings":"AAAA,sBACI,eAAA,CACA,eAAA,CAGJ,sBACI,aAAA","sourcesContent":[".viewActions {\n    flex-wrap: unset;\n    overflow-x: auto;\n}\n\n.viewActionsButtons {\n    flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewActions": `VmpJpXusOUpJVZaBvBFA`,
	"viewActionsButtons": `oWV6gR_AC4h6b2ZTX9SM`
};
export default ___CSS_LOADER_EXPORT___;
